// Copyright (c) Docugami, Inc. All rights reserved.

import styled from "styled-components"
import { ExplorerViewType, NavigationGroup } from "./ExplorerTypes"
import { ExplorerViewFactory } from "./ExplorerViewFactory"

const CanvasContainer = styled.div`
    height: 100%;
    width: 100%;
    box-sizing: border-box;
`

interface ExplorerCanvasProps {
    group?: NavigationGroup,
    itemId?: string,
    type?: ExplorerViewType
}

export const ExplorerCanvas = (props: ExplorerCanvasProps): JSX.Element => {
    return (
        <CanvasContainer>
            <ExplorerViewFactory {...props} />
        </CanvasContainer>
    )
}
